import script from "./GroupSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./GroupSettingPage.vue?vue&type=style&index=0&id=3ce0cf18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce0cf18"]])

export default __exports__